import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { BackendStorageSelectors } from './backend-storage.selectors';
import { BackendStorageActions } from './backend-storage.actions';

@Injectable({ providedIn: 'root' })
export class BackendStorageStore {
  constructor(private store: Store) {}

  state$ = this.store.select(BackendStorageSelectors.backendStorageState);
  advertBannerVisibility$ = this.store.select(BackendStorageSelectors.selectAdvertBannerVisibility);

  setKeyValue(key: any, value: any): void {
    this.store.dispatch(BackendStorageActions.SetKeyValue({ key, value }));
  }

  getKeyValue(key: any): void {
    this.store.dispatch(BackendStorageActions.GetKeyValue({ key }));
  }
}
